const handleVideoGallery = () => {
    const selectors = {
        container: '.js-video-gallery',
        video: '.js-video-gallery-video',
        overlay: '.js-video-gallery-overlay',
    }
    const containers = document.querySelectorAll(selectors.container);
    containers.forEach(container => {
        const video = container.querySelector(selectors.video);
        const overlay = container.querySelector(selectors.overlay);
        if(video && overlay){
            container.addEventListener('click', () => {
                video.classList.add('is-active');
                video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                overlay.classList.remove('is-active');
            });
            document.addEventListener('pointerdown', e => {
                if(!container.contains(e.target)){
                    video.classList.remove('is-active');
                    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    overlay.classList.add('is-active');
                }
            });
        }
    });
}
export default handleVideoGallery;